export default function Footer() {
  return (
    <footer id="footer" className="bg-background-900 text-foreground-300">
      <div className="w-full px-4 md:px-6 py-14 md:py-16">
        <div className="max-w-[1280px] mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
            <div className="lg:col-span-1">
              <a href="#hero" className="inline-flex items-center gap-2 mb-4 cursor-pointer">
                <span className="text-xl font-bold font-heading text-primary-400">91麻豆</span>
                <span className="text-sm text-foreground-400">免费视频网站</span>
              </a>
              <p className="text-sm text-foreground-500 leading-relaxed">
                91麻豆免费视频网站提供海量免费在线视频资源，
                涵盖91免费在线视频、91免费视频网站等热门频道，
                免费视频在线观看、在线免费视频网站一网打尽，
                免费高清视频在线不缓冲流畅播放。
              </p>
            </div>

            <div>
              <h3 className="text-sm font-semibold text-foreground-200 mb-4 font-heading">快速导航</h3>
              <ul className="space-y-2.5">
                <li><a href="#updates" className="text-sm text-foreground-500 hover:text-primary-400 transition-colors cursor-pointer">最新动态</a></li>
                <li><a href="#topics" className="text-sm text-foreground-500 hover:text-primary-400 transition-colors cursor-pointer">热门话题</a></li>
                <li><a href="#faq" className="text-sm text-foreground-500 hover:text-primary-400 transition-colors cursor-pointer">常见问题</a></li>
                <li><a href="#media" className="text-sm text-foreground-500 hover:text-primary-400 transition-colors cursor-pointer">视频专区</a></li>
                <li><a href="#ranking" className="text-sm text-foreground-500 hover:text-primary-400 transition-colors cursor-pointer">热门榜单</a></li>
              </ul>
            </div>

            <div>
              <h3 className="text-sm font-semibold text-foreground-200 mb-4 font-heading">推荐频道</h3>
              <ul className="space-y-2.5">
                <li><span className="text-sm text-foreground-500">91免费在线视频</span></li>
                <li><span className="text-sm text-foreground-500">91免费视频网站</span></li>
                <li><span className="text-sm text-foreground-500">91福利在线视频</span></li>
                <li><span className="text-sm text-foreground-500">免费视频在线观看</span></li>
                <li><span className="text-sm text-foreground-500">在线免费视频网站</span></li>
              </ul>
            </div>

            <div>
              <h3 className="text-sm font-semibold text-foreground-200 mb-4 font-heading">合作伙伴</h3>
              <ul className="space-y-2.5">
                <li><span className="text-sm text-foreground-500">—— 虚位以待 ——</span></li>
              </ul>
            </div>
          </div>

          <div className="border-t border-background-700 mt-12 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-foreground-600">
              &copy; {new Date().getFullYear()} 91麻豆免费视频网站. 本站内容仅供成年人浏览，未满18岁请自觉离开。
            </p>
            <div className="flex items-center gap-4">
              <span className="text-xs text-foreground-600">免费高清视频在线</span>
              <span className="text-xs text-foreground-600">即点即播不缓冲</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}